import { Availability } from '../../generated/graphql';
export var toISOStringWithoutMilliseconds = function (date) {
    return date.toISOString().slice(0, -5) + 'Z';
};
/**
 * Function maps space state to map state type
 * @param space Space availability
 * @returns Map state
 */
export function mapSpaceStateToMapType(space, meetsFilterCriteria) {
    var _a;
    var result = {
        restricted: false,
        reduced: false,
        available: false,
        disabled: false,
        booked: false,
        inUse: false,
        warning: false,
    };
    if (!space) {
        return result;
    }
    if (space.isDisabled) {
        result.disabled = true;
    }
    // space is either on-demand (must book from tablet) or requires admin approval
    if (!((_a = space.calendar) === null || _a === void 0 ? void 0 : _a.calendarId) || space.isManaged || !meetsFilterCriteria) {
        result.restricted = true;
    }
    var firstAvailability = space.windowedAvailability[0];
    switch (firstAvailability === null || firstAvailability === void 0 ? void 0 : firstAvailability.status) {
        case Availability.Available:
            result.available = true;
            break;
        case Availability.Booked:
            result.booked = true;
            break;
        case Availability.Unavailable:
            result.inUse = true;
            break;
        case Availability.Unknown:
            result.disabled = true;
            break;
        default:
            break;
    }
    return result;
}
export var transformSpaceAPIToSpaceType = function (space) {
    var _a;
    return {
        id: space.id,
        name: space.name,
        capacity: space.capacity,
        description: space.description,
        image: space.image,
        locationId: space.location_id,
        levelId: space.level_id,
        isManaged: space.is_managed,
        calendar: space.calendar
            ? {
                calendarId: space.calendar.calendar_id,
                createdAt: space.calendar.created_at,
                remoteType: space.calendar.remote_type,
                spaceId: space.calendar.space_id.toString(),
                spaceResourceEmail: space.calendar.space_resource_email,
            }
            : null,
        permissions: space.permissions,
        amenities: space.space_amenities.map(function (amenity) { return ({
            id: amenity.id,
            quantity: amenity.quantity,
            amenityId: amenity.amenity_id,
            name: amenity.amenity.name,
        }); }),
        settings: (_a = space.settings) === null || _a === void 0 ? void 0 : _a.map(function (setting) { return ({
            name: setting.name,
            slug: setting.slug,
            value: setting.value,
        }); }),
    };
};
